export { default as default } from './OffCanvasBlockComponent.jsx';